/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import type {TableProps} from 'antd/lib/table';
import type {ReadingTaskRow} from './types';
import {CellElement, RowElement} from '../common/tableComponents';

export const TableElement: React.FC<
  React.TableHTMLAttributes<HTMLTableElement>
> = ({ style, children, ...rest }) => {
  const baseStyle: React.CSSProperties = {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    tableLayout: 'fixed',
    width: '100%',
  };

  const mergedStyle = style ? { ...style, ...baseStyle } : baseStyle;

  const childArray = React.Children.toArray(children);
  const hasThead = childArray.some(
    child => React.isValidElement(child) && child.type === 'thead'
  );

  if (hasThead) {
    return (
      <table {...rest} style={mergedStyle}>
        {children}
      </table>
    );
  }

  return (
    <table {...rest} style={mergedStyle}>
      <thead
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        <tr>
          <th scope='col'>Reading tasks</th>
        </tr>
      </thead>
      {children}
    </table>
  );
};

export const components: TableProps<ReadingTaskRow>['components'] = {
  table: TableElement,
  body: { row: RowElement, cell: CellElement },
};

export const rowClassName = (row: ReadingTaskRow) =>
  row.type === 'group' ? '' : 'bg-transparent';

export const onRow: NonNullable<TableProps<ReadingTaskRow>['onRow']> = row => ({
  className: row.type === 'detail' ? 'detail-row' : 'group-row',
});
